/**
 * Expect the current page starts from 0, that's why it's decreasing
 * 1 of the totalPages to execute the logic to get the real currentPage.
 * It's required in case of some delete operation update the total results,
 * and in tha scenario the current page will not exist anymore
 *
 * @param currentPage
 * @param pageLength
 * @param total
 * @returns
 */
export function getPaginationDetails(currentPage, pageLength, total) {
  const totalPagesIndex = Math.ceil(total / pageLength) - 1;
  currentPage = currentPage > totalPagesIndex ? totalPagesIndex : currentPage;
  const firstOfPage = currentPage * pageLength + 1;
  const endFullPage = firstOfPage + pageLength - 1;
  const lastOfPage = endFullPage > total ? total : endFullPage;
  return {
    currentPage,
    firstOfPage,
    lastOfPage,
  };
}

export function getPaginationMessage(currentPage, pageLength, total) {
  const { firstOfPage, lastOfPage } = getPaginationDetails(currentPage, pageLength, total);
  return `Showing ${firstOfPage}-${lastOfPage} of ${total} Results`;
}